import { createFileRoute } from '@tanstack/react-router';
import { BranchesPage } from '@/features/tenant/pages/branches-page';

export const Route = createFileRoute('/_app/settings/branches')({ component: BranchesPage });
